/**
 * WordPress dependencies
 */
import { SVG, Path, Defs, G } from '@wordpress/primitives';

const Upgrade = (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 17"
		fill="none"
		className="pum-icon pum-icon--upgrade"
	>
		<G clipPath="url(#clip0_592_16835)">
			<Path
				d="M13 6.5C12.8011 6.5 12.6103 6.42098 12.4697 6.28033C12.329 6.13968 12.25 5.94891 12.25 5.75C12.25 5.35218 12.092 4.97064 11.8107 4.68934C11.5294 4.40804 11.1478 4.25 10.75 4.25C10.5511 4.25 10.3603 4.17098 10.2197 4.03033C10.079 3.88968 10 3.69891 10 3.5C10 3.30109 10.079 3.11032 10.2197 2.96967C10.3603 2.82902 10.5511 2.75 10.75 2.75C11.1478 2.75 11.5294 2.59196 11.8107 2.31066C12.092 2.02936 12.25 1.64782 12.25 1.25C12.25 1.05109 12.329 0.860322 12.4697 0.71967C12.6103 0.579018 12.8011 0.5 13 0.5C13.1989 0.5 13.3897 0.579018 13.5303 0.71967C13.671 0.860322 13.75 1.05109 13.75 1.25C13.75 1.64782 13.908 2.02936 14.1893 2.31066C14.4706 2.59196 14.8522 2.75 15.25 2.75C15.4489 2.75 15.6397 2.82902 15.7803 2.96967C15.921 3.11032 16 3.30109 16 3.5C16 3.69891 15.921 3.88968 15.7803 4.03033C15.6397 4.17098 15.4489 4.25 15.25 4.25C14.8522 4.25 14.4706 4.40804 14.1893 4.68934C13.908 4.97064 13.75 5.35218 13.75 5.75C13.75 5.94891 13.671 6.13968 13.5303 6.28033C13.3897 6.42098 13.1989 6.5 13 6.5Z"
				fill="#000000"
			/>
			<Path
				d="M6 16.5C5.73478 16.5 5.48043 16.3946 5.29289 16.2071C5.10536 16.0196 5 15.7652 5 15.5C5 14.4391 4.57857 13.4217 3.82843 12.6716C3.07828 11.9214 2.06087 11.5 1 11.5C0.734784 11.5 0.48043 11.3946 0.292893 11.2071C0.105357 11.0196 0 10.7652 0 10.5C0 10.2348 0.105357 9.98043 0.292893 9.79289C0.48043 9.60536 0.734784 9.5 1 9.5C2.06087 9.5 3.07828 9.07857 3.82843 8.32843C4.57857 7.57828 5 6.56087 5 5.5C5 5.23478 5.10536 4.98043 5.29289 4.79289C5.48043 4.60536 5.73478 4.5 6 4.5C6.26522 4.5 6.51957 4.60536 6.70711 4.79289C6.89464 4.98043 7 5.23478 7 5.5C7 6.56087 7.42143 7.57828 8.17157 8.32843C8.92172 9.07857 9.93913 9.5 11 9.5C11.2652 9.5 11.5196 9.60536 11.7071 9.79289C11.8946 9.98043 12 10.2348 12 10.5C12 10.7652 11.8946 11.0196 11.7071 11.2071C11.5196 11.3946 11.2652 11.5 11 11.5C9.93913 11.5 8.92172 11.9214 8.17157 12.6716C7.42143 13.4217 7 14.4391 7 15.5C7 15.7652 6.89464 16.0196 6.70711 16.2071C6.51957 16.3946 6.26522 16.5 6 16.5Z"
				fill="#000000"
			/>
		</G>
		<Defs>
			<clipPath id="clip0_592_16835">
				<rect width="16" height="16" transform="translate(0 0.5)" />
			</clipPath>
		</Defs>
	</SVG>
);

export default Upgrade;
